import { getMUICache, appendStyleSheet, getImageUrl, getImageSize, GetFallBackImage, isImageSizeBlank, getImageId, fetchAnchorValue, isUpdatedWithin24Hours } from '../../../common/utils';
import { CacheProvider } from '@emotion/react';
import "./RhsHomeTwo.css";
import { EagerLoadImages, AddImageDimensions, SetHighPriorityImages, PreloadViewportImages, ImageLoader } from '../../../components/IntersectionObserver/imageComponent';
import { useEffect } from 'react';

const Card = (props: any) => {
  const { item, showAuthorName, showHeading, anchorLinksValue } = props;

  AddImageDimensions();
  SetHighPriorityImages();
  PreloadViewportImages();
  ImageLoader();
  const { hl, au, imageid, wu } = item;
  const cache = getMUICache();
  let styles = require("./RhsHomeTwo.css");
  appendStyleSheet("RhsHomeTwo", styles);

  useEffect(() => {
    EagerLoadImages();
  }, [])

  return (
    <CacheProvider value={cache}>
      {/* <div style={{ backgroundColor: props.cardBGColor }}> </div> */}
      {showHeading && <div className='ThemeTwoRhsHeadingWrap'>
        <p className='ThemeTwoRhsHomeHeading themeTwoCommonComponentsHeading' style={{ color: props.mainHeadingColor }}>{props.mainHeading}</p>
      </div>}
      <a href={wu} target={fetchAnchorValue(anchorLinksValue, wu)} className='themeTwoRhsHomeWraper'>
        <div className='themeTwoRhsHomeContentWraper liveBlogHeadingBox listBlogWrapper'>
          <div className='themeTwoRhsHomeTitle'>
            {item.tn === 'LIVEBLOG' && (
              <span className={`liveBlogCommonLiveHeading ${isUpdatedWithin24Hours(item?.lpt, item?.upd) ? "liveBlogAnimationHeading" : "liveBlogNoneAnimationHeading"}`}>
                {isUpdatedWithin24Hours(item?.lpt, item?.upd) && (
                  <>
                    <i></i>
                    Live {' '}
                    <span style={{ margin: '0px 4px', color: '#000' }}>|</span>
                  </>
                )}
              </span>
            )}

            {hl}
          </div>
          {showAuthorName && <div className='themeTwoRhsViewAuthWrap'>
            <p className='themeTwoRhsViewAgency commonListViewAuth'>By <span>{au}</span></p>
          </div>
          }
        </div>
        <div className='themeTwoRhsHomeImageWraper'>
          {isImageSizeBlank(imageid) ?
            <picture>
              {/* Add multiple source elements for different image sources */}
              <source media="(min-width: 768px)" srcSet={getImageUrl(getImageId(imageid), getImageSize(imageid), 72, 54, "", false, props.CONSTANTS, '3')} />

              <source media="(max-width: 767px)" srcSet={getImageUrl(getImageId(imageid), getImageSize(imageid), 72, 54, "", false, props.CONSTANTS, '3')} />

              <img alt={hl?.slice(0, 25)} title={hl?.slice(0, 25)} loading="lazy" />
            </picture> :
            <img src={GetFallBackImage()} alt={hl?.slice(0, 25)} title={hl?.slice(0, 25)} loading="lazy" />
          }
        </div>
      </a>



    </CacheProvider>
  )
}
export default Card;